import React, { Component, createRef } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { Layout, Menu, Modal, Radio, Mentions, Form, Input, Select, Row, Col, Avatar, Dropdown } from "antd";
import {
  AndroidFilled,
  LogoutOutlined,
  HomeOutlined,
  SettingOutlined,
  CloudServerOutlined,
  DashboardOutlined,
  AppstoreAddOutlined,
  TableOutlined,
  FolderOutlined,
  TagOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";

import { getBoardsAsync, getGroupsAsync, updateSelectedBoard } from "../../redux/boardSlice";
import { addDashboardConfig } from "../../redux/editorSlice";
import { getAppsAsync, setOtherUsers, signout } from "../../redux/userSlice";
import AddApps from "../../components/AddApps";
import AddBoardGroup from "../../components/BoardGoups/AddBoardGroup";
import MaterialDesignIcon from "../../components/common/MaterialDesignIcon";

const { Header, Sider, Content } = Layout;
const { Option } = Mentions;

const ORG_LIST = [
  { OrganisationID: "1", Name: "Org 1" },
  { OrganisationID: "2", Name: "Org 2" },
];

class DashboardView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 1,
      visible: false,
      sharedListShow: true,
      rtype: "",
      dashboardName: "",
      boardNamerror: false,
      users: [],
      usersList: [],
      userIdList: [],
      sharedOrgIdList: [],
      addedApps: false,
      isAppsMultiSelectEnabled: true,
      appList: [],
      groupMenuVissible: false,
      selectedGoup: null,
      goupError: false,
      selectedSubGoupId: "none",
      isGroupModalVisible: false,
    };
    this.addBoardGroupRef = createRef();
  }

  handleLogOut = () => {
    this.props.logOut();
    this.props.history.push("/");
  };

  showModal = (type) => {
    this.setState({
      visible: true,
      value: 1,
      rtype: type,
    });
  };

  handleOk = () => {
    if (this.state.dashboardName === "") {
      this.setState({ boardNamerror: true });
    } else if (!this.state.selectedGoup) {
      this.setState({ goupError: true });
      return;
    } else {
      this.setState({ visible: false });
      // ...save config logic here
      if (this.state.rtype === "reports") {
        this.props.history.push("/editor/reports");
      } else {
        this.props.history.push("/editor/dashboard");
      }
    }
  };

  handleCancel = () => {
    this.setState({ visible: false });
  };

  onChangeRadio = (e) => {
    if (e.target.value === 2) {
      this.setState({ sharedListShow: false, value: 2 });
    } else if (e.target.value === 3) {
      this.setState({ sharedListShow: false, value: 3 });
    } else {
      this.setState({ sharedListShow: true, value: 1 });
    }
  };

  onSelectSharableOrganizations = (e) => {
    let orgs = [...this.state.sharedOrgIdList];
    orgs.push(e.value);
    this.setState({ sharedOrgIdList: [...new Set(orgs)] });
  };

  handleFinishSelectApps = (apps) => {
    this.setState({ appList: apps, addedApps: apps.length > 0 });
  };

  onChangeGoupSearch = (value) => {
    this.setState({
      selectedGoup: this.props.dashboardGroups.find((gd) => gd.id === value),
      goupError: false,
    });
  };

  handleAddGroup = () => {
    this.setState({ isGroupModalVisible: true });
  };

  handleAddResource = () => {
    this.props.history.push("/add-resource");
  };

  handleAddDashboard = (boardType) => {
    this.showModal(boardType);
  };

  handleOkGpModal = () => {
    this.setState({ isGroupModalVisible: false });
  };

  handleCancelGpModal = () => {
    if (this.addBoardGroupRef.current && this.addBoardGroupRef.current.resetToInitialState) {
      this.addBoardGroupRef.current.resetToInitialState();
    }
    this.setState({ isGroupModalVisible: false });
  };

  render() {
    const user = JSON.parse(localStorage.getItem("fullUserDetails") || "{}");
    const avatarValue = user.FirstName ? user.FirstName.charAt(0) + user.LastName.charAt(0) : "U";
    return (
      <div>
        <Layout style={{ minHeight: "100vh" }}>
          <Sider width={220} theme="light">
            <div style={{ padding: 16, textAlign: "center" }}>
              <img
                src="https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSG5Omn5Fd0IYMYavsfGgXhc2guce2dLKv01X7zxSkPcO6kE4ZiVoqre-VOGLDSHPpEAZE&usqp=CAU"
                alt="logo"
                style={{ width: 48, borderRadius: 8 }}
              />
              <div style={{ marginTop: 8, fontWeight: "bold" }}>Witmeg Reporting</div>
              <div style={{ fontSize: 12, color: "#888" }}>Report Engine</div>
            </div>
            <Menu mode="inline" defaultSelectedKeys={["home"]}>
              <Menu.Item key="home" icon={<HomeOutlined />} onClick={() => this.props.history.push("/")}>
                Home
              </Menu.Item>
              <Menu.SubMenu key="addnew" icon={<AppstoreAddOutlined />} title="Add New">
                <Menu.Item key="group" icon={<TagOutlined />} onClick={this.handleAddGroup}>
                  Group
                </Menu.Item>
                <Menu.Item key="resource" icon={<CloudServerOutlined />} onClick={this.handleAddResource}>
                  Resource
                </Menu.Item>
                <Menu.Item
                  key="dashboard"
                  icon={<DashboardOutlined />}
                  onClick={() => this.handleAddDashboard("dashboard")}
                >
                  Report / Dashboard
                </Menu.Item>
              </Menu.SubMenu>
              <Menu.Item key="groups" icon={<FolderOutlined />} onClick={() => this.props.history.push("/groups")}>
                Groups
              </Menu.Item>
              <Menu.Item
                key="resources"
                icon={<CloudServerOutlined />}
                onClick={() => this.props.history.push("/resources")}
              >
                Resources
              </Menu.Item>
              <Menu.Item key="settings" icon={<SettingOutlined />}>
                Account Settings
              </Menu.Item>
              <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={this.handleLogOut}>
                Log Out
              </Menu.Item>
              <Menu.Item key="schedule" icon={<TableOutlined />} onClick={() => this.props.history.push("/scheduling")}>
                Report Schedule
              </Menu.Item>
            </Menu>
          </Sider>
          <Layout>
            <Header
              style={{
                background: "#fff",
                padding: "0 24px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
            >
              <div>
                <span style={{ fontWeight: "bold", fontSize: 18 }}>Dynamic Reports</span>
                <span style={{ marginLeft: 12, color: "#888" }}>Customize Easy</span>
              </div>
              <Dropdown
                overlay={
                  <Menu>
                    <Menu.Item key="logout" icon={<LogoutOutlined />} onClick={this.handleLogOut}>
                      Log Out
                    </Menu.Item>
                  </Menu>
                }
              >
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    cursor: "pointer",
                  }}
                >
                  <Avatar style={{ backgroundColor: "#1890ff", marginRight: 8 }} icon={<AndroidFilled />} size="small">
                    {avatarValue}
                  </Avatar>
                  <span>
                    {user.FirstName} {user.LastName}
                  </span>
                </div>
              </Dropdown>
            </Header>
            <Content style={{ margin: 24, background: "#fff", minHeight: 360 }}>
              {/* Main content goes here */}
              {this.props.children}
            </Content>
          </Layout>
          <Modal
            visible={this.state.visible}
            onOk={this.handleOk}
            onCancel={this.handleCancel}
            okText={this.state.rtype === "reports" ? "Create report" : "Create board"}
            okButtonProps={{
              style: {
                display: this.state.addedApps ? "inline-flex" : "none",
              },
            }}
            cancelButtonProps={{
              style: {
                display: this.state.addedApps ? "inline-flex" : "none",
              },
            }}
            width={720}
          >
            {this.state.addedApps ? (
              <>
                <h2>Create new {this.state.rtype === "reports" ? "report" : "board"}</h2>
                <Form.Item
                  name="boardname"
                  rules={[{ required: true, message: "Please input board name!" }]}
                  validateStatus={this.state.boardNamerror ? "error" : ""}
                >
                  <Input
                    placeholder={this.state.rtype === "reports" ? "Report Name" : "Report or Dashboard Name"}
                    value={this.state.dashboardName}
                    onChange={(e) => {
                      this.setState({
                        dashboardName: e.target.value,
                        boardNamerror: false,
                      });
                    }}
                  />
                </Form.Item>
                <Form.Item name="accesstype" rules={[{ required: true, message: "Please select access type!" }]}>
                  <div className="report-radiobtn-container">
                    <Radio.Group onChange={this.onChangeRadio} value={this.state.value}>
                      <Radio value={1}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <MaterialDesignIcon icon="fingerprint" /> <span>Private</span>
                        </div>
                      </Radio>
                      <Radio value={2}>
                        <div style={{ display: "flex", alignItems: "center" }}>
                          <MaterialDesignIcon icon="groups" />
                          <span>Public</span>
                        </div>
                      </Radio>
                      {localStorage.getItem("IsSpecialUser") === "true" ? (
                        <Radio value={3}>
                          <div style={{ display: "flex", alignItems: "center" }}>
                            <MaterialDesignIcon icon="public" />
                            <span>&nbsp;Global</span>
                          </div>
                        </Radio>
                      ) : null}
                    </Radio.Group>
                  </div>
                  {this.state.sharedListShow ? (
                    <>
                      <Row>
                        <Col span={6}>
                          <div>Organization</div>
                        </Col>
                        <Col span={18}>
                          <Mentions style={{ width: "100%" }} id="users" onSelect={this.onSelectSharableOrganizations}>
                            {ORG_LIST.map((org) => (
                              <Option data={org} value={org.Name} key={org.OrganisationID}>
                                {org.Name}
                              </Option>
                            ))}
                          </Mentions>
                        </Col>
                      </Row>
                      <Row>
                        <Col span={6}>
                          <div>Organization</div>
                        </Col>
                        <Col span={6}>
                          <div>
                            <Input placeholder="small size" prefix={<CloseCircleOutlined fill="#ddd" />} />
                          </div>
                        </Col>
                        <Col span={6}>
                          <div>
                            <Select>
                              <Select.Option>Group1</Select.Option>
                              <Select.Option>Group2</Select.Option>
                            </Select>
                          </div>
                        </Col>
                      </Row>
                    </>
                  ) : null}
                </Form.Item>
                {this.state.value === 3 ? (
                  <>
                    <Row>
                      <Col span={6}>
                        <div>Group Name (Required) :</div>
                      </Col>
                      <Col span={18}>
                        <Form.Item
                          name="mainGroupName"
                          rules={[
                            {
                              required: true,
                              message: "Please select goup!",
                            },
                          ]}
                          validateStatus={this.state.goupError ? "error" : ""}
                        >
                          <Select
                            showSearch
                            style={{ width: 200 }}
                            placeholder="Select Goup"
                            optionFilterProp="children"
                            onChange={this.onChangeGoupSearch}
                          >
                            {this.state.rtype === "reports"
                              ? this.props.reportGroups
                                  .filter((r) => r.isGlobal)
                                  .map((dg) => (
                                    <Select.Option key={dg.id} value={dg.id}>
                                      {dg.title}
                                    </Select.Option>
                                  ))
                              : this.props.dashboardGroups
                                  .filter((r) => r.isGlobal)
                                  .map((dg) => (
                                    <Select.Option key={dg.id} value={dg.id}>
                                      {dg.title}
                                    </Select.Option>
                                  ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                    {this.state.selectedGoup &&
                    this.state.selectedGoup.children &&
                    this.state.selectedGoup.children.length > 0 ? (
                      <Row>
                        <Col span={6}>
                          <div>Sub Group Name (Optional) :</div>
                        </Col>
                        <Col span={18}>
                          <Select
                            showSearch
                            style={{ width: 200 }}
                            placeholder="Select sub group"
                            optionFilterProp="children"
                            onChange={(val) => this.setState({ selectedSubGoupId: val })}
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            <Select.Option key="no_sub" value="none">
                              None
                            </Select.Option>
                            {this.state.selectedGoup.children.map((c) => (
                              <Select.Option key={c.id} value={c.id}>
                                {c.title}
                              </Select.Option>
                            ))}
                          </Select>
                        </Col>
                      </Row>
                    ) : null}
                  </>
                ) : (
                  <>
                    <Row>
                      <Col span={6}>
                        <div>Group Name (Required) :</div>
                      </Col>
                      <Col span={18}>
                        <Form.Item
                          name="mainGroupName"
                          rules={[
                            {
                              required: true,
                              message: "Please select goup!",
                            },
                          ]}
                          validateStatus={this.state.goupError ? "error" : ""}
                        >
                          <Select
                            showSearch
                            style={{ width: 200 }}
                            placeholder="Select Goup"
                            optionFilterProp="children"
                            onChange={this.onChangeGoupSearch}
                          >
                            {this.state.rtype === "reports"
                              ? this.props.reportGroups
                                  .filter((r) => !r.isGlobal)
                                  .map((dg) => (
                                    <Select.Option key={dg.id} value={dg.id}>
                                      {dg.title}
                                    </Select.Option>
                                  ))
                              : this.props.dashboardGroups
                                  .filter((r) => !r.isGlobal)
                                  .map((dg) => (
                                    <Select.Option key={dg.id} value={dg.id}>
                                      {dg.title}
                                    </Select.Option>
                                  ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                    {this.state.selectedGoup &&
                    this.state.selectedGoup.children &&
                    this.state.selectedGoup.children.length > 0 ? (
                      <Row>
                        <Col span={6}>
                          <div>Sub Group Name (Optional) :</div>
                        </Col>
                        <Col span={18}>
                          <Select
                            showSearch
                            style={{ width: 200 }}
                            placeholder="Select sub group"
                            optionFilterProp="children"
                            onChange={(val) => this.setState({ selectedSubGoupId: val })}
                            filterOption={(input, option) =>
                              option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                            }
                          >
                            <Select.Option key="no_sub" value="none">
                              None
                            </Select.Option>
                            {this.state.selectedGoup.children.map((c) => (
                              <Select.Option key={c.id} value={c.id}>
                                {c.title}
                              </Select.Option>
                            ))}
                          </Select>
                        </Col>
                      </Row>
                    ) : null}
                  </>
                )}
              </>
            ) : (
              <>
                <div>
                  <h2>Add Apps</h2>
                </div>
                <div>
                  <AddApps
                    multiSelectEnabled={this.state.isAppsMultiSelectEnabled}
                    onFinishSelect={this.handleFinishSelectApps}
                  />
                </div>
              </>
            )}
          </Modal>
          <Modal
            title="Add New Group"
            visible={this.state.isGroupModalVisible}
            onOk={this.handleOkGpModal}
            onCancel={this.handleCancelGpModal}
            footer={null}
            okText="Save Group"
            width={720}
          >
            <AddBoardGroup
              ref={this.addBoardGroupRef}
              users={this.state.users}
              handleCloseModal={this.handleCancelGpModal}
            />
          </Modal>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { boards, user } = state;
  return {
    boardsStatus: boards.boardsData.boardsStatus,
    dashboardList: boards.boardsData.filter((bd) => bd.configDetails.boardType === "dashboard"),
    reportList: boards.boardsData.filter((bd) => bd.configDetails.boardType === "reports"),
    dashboardGroups: boards.groups
      ? boards.groups
          .filter((gd) => gd.groupType === "dashboard")
          .sort((a, b) => (a.title < b.title ? -1 : a.title > b.title ? 1 : 0))
      : null,
    reportGroups: boards.groups
      ? boards.groups
          .filter((gd) => gd.groupType === "report")
          .sort((a, b) => (a.title < b.title ? -1 : a.title > b.title ? 1 : 0))
      : null,
    currentAppPermissions: user.currentAppPermissions ? user.currentAppPermissions : [],
    accessToken: user?.user?.accessToken,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    logOut: () => dispatch(signout()),
    setDashboardConfig: (details) => dispatch(addDashboardConfig(details)),
    getBoards: (t) => dispatch(getBoardsAsync(t)),
    addSelectedBoard: (board) => dispatch(updateSelectedBoard(board)),
    getApps: () => dispatch(getAppsAsync()),
    setOtherUsers: (usersList) => dispatch(setOtherUsers(usersList)),
    getGroups: (t) => dispatch(getGroupsAsync(t)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(DashboardView));
